import React, { useState } from "react";
import { Button, Tab } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import { ListRole, RoleForm } from "../../../components/Admin/Role";
import "./Role.scss";

export function Role() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListRole reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="role-page">
        <Button className="role-page__add" primary onClick={onOpenCloseModal}>
          Nuevo tipo de usuario
        </Button>
        <Tab menu={{ secondary: true }} panes={panes} />
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title="Crear tipo de usuario">
        <RoleForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  );
}
